import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getBlogs } from "../../../api/blogs";
import { isBlogCoverFallback, resolveBlogCoverSrc } from "../../../utils/blogImages";
import { isBlogPublished } from "../../../utils/blogStatus";
import BlogListLoader from "../../../components/Blog/BlogListLoader";
import "./Blog.css";
import SEO from "../../../utils/SEO";

function stripHtml(value) {
    return String(value || "").replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
}

function formatDate(value) {
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}.${month}.${day}`;
}

export default function Blog () {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        let cancelled = false;

        const fetchBlogs = async () => {
            try {
                const data = await getBlogs();
                if (cancelled) return;
                const list = Array.isArray(data) ? data.filter(isBlogPublished) : [];
                setBlogs(list);
            } catch (err) {
                if (cancelled) return;
                const msg =
                    err?.response?.data?.message ||
                    err?.message ||
                    "Failed to load blog posts. Please try again.";
                setError(msg);
            } finally {
                if (cancelled) return;
                setLoading(false);
            }
        };

        fetchBlogs();
        return () => {
            cancelled = true;
        };
    }, []);

    return (
        <main className='main'>
            <SEO
                title="Offshore Advisory Blog | Global Finance & Licensing News "
                description="Explore insights on offshore company formation, licensing, banking, residency, and global tax strategies. Expert updates for entrepreneurs and investors. "
                keywords="offshore advisory blog, offshore finance news, company formation guides, financial licensing insights, global tax strategies, residency programs blog, fintech updates, offshore banking news "
                url="/blogs"
            />
            <div className="pbl-background">
                <div className="pbl-container">
                    <h2 className="pbl-title">
                        Our News & Blog
                    </h2>
                   {loading ? (
                        <BlogListLoader count={6} />
                    ) : error ? (
                        <div className="pbl-box">
                            <div className="pbl-state-card pbl-state-card--error" role="alert">
                                <h3 className="pbl-state-title">Could not load blog posts</h3>
                                <p className="pbl-state-text">{error}</p>
                            </div>
                        </div>
                    ) : blogs.length === 0 ? (
                        <div className="pbl-box">
                            <div className="pbl-state-card">No blogs published yet.</div>
                        </div>
                    ) : (
                        <div className="pbl-cards">
                            {blogs.map((blog) => {
                                const dateLabel = formatDate(blog?.createdAt);
                                const intro = blog?.intro || stripHtml(blog?.content || "");
                                const imageSrc = resolveBlogCoverSrc(blog?.image);
                                const coverIsFallback = isBlogCoverFallback(blog?.image);
                                const blogSlug = blog?.slug || blog?._id;

                                return (
                                    <Link to={`/blogs/${blogSlug}`} className="pbl-item" key={blog?._id || blogSlug}>
                                        <div>
                                            <div className="pbl-image-wrap">
                                                <img
                                                    className={coverIsFallback ? "pbl-cover-fallback" : undefined}
                                                    src={imageSrc}
                                                    alt={coverIsFallback ? "Offshore Advisory" : (blog?.title || "Blog cover")}
                                                />
                                            </div>
                                            <h3 className="pbl-item-title">
                                                {blog?.title || "Untitled post"}
                                            </h3>
                                            <div className="pbl-item-desc-wrap">
                                                <p className="pbl-item-desc">
                                                    {intro ? `${intro.substring(0, 150)}${intro.length > 150 ? "..." : ""}` : "Read the full story."}
                                                </p>
                                            </div>
                                            <div className="pbl-meta-row">
                                                <div className="pbl-item-date">
                                                    {dateLabel}
                                                </div>
                                                <span className="pbl-read-more">
                                                    Read more
                                                </span>
                                            </div>
                                        </div>
                                    </Link>
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>
            {/* <Footer /> */}
        </main>
    )
}